import type { TranslationDict } from '../en';

const lt: TranslationDict = {
  'header.buy': 'Pirkti',
  'header.sell': 'Parduoti',
  'spend.label': 'Jūs išleidžiate',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Jūs gaunate',
  'payment.label': 'Mokėjimo būdas',
  'payment.select': 'Pasirinkti',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Nėra mokėjimo būdų šiai porai',
  'wallet.label': 'Gavėjo piniginės adresas',
  'wallet.placeholderBuy': 'Įveskite gavėjo adresą',
  'wallet.placeholderSell': 'Įveskite siuntėjo adresą',
  'wallet.validating': 'Tikrinamas adresas...',
  'wallet.invalid': 'Įveskite tinkamą piniginės adresą',
  'wallet.invalidServer': 'Netinkamas piniginės adresas',
  'cta.buy': 'Pirkti {crypto}',
  'cta.sell': 'Parduoti {crypto}',
  'cta.gettingPrice': 'Ieškoma geriausia kaina...',
  'cta.processing': 'Apdorojama...',
  'footer.poweredBy': 'Veikia su ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Kurso išsami informacija',
  'rate.close': 'Uždaryti',
  'rate.updatesIn': 'Kursas atnaujinamas po 00:{seconds}',
  'rate.noQuote': 'Nėra pasiekiamos kainos',
  'rate.exchangeRate': 'Valiutos kursas',
  'rate.processingFee': 'Apdorojimo mokestis',
  'rate.networkFee': 'Tinklo mokestis',
  'rate.provider': 'Teikėjas',
  'toast.orderCreated': 'Užsakymas sukurtas',
  'toast.redirecting': 'Nukreipiama į atsiskaitymą...',
  'toast.orderFailed': 'Užsakymas nepavyko',
  'toast.couldNotCreate': 'Nepavyko sukurti užsakymo',
  'toast.quoteError': 'Kainos klaida',
  'toast.noProviders': 'Nėra teikėjų',
  'toast.somethingWrong': 'Kažkas nutiko ne taip',
  'error.amountZero': 'Suma turi būti didesnė nei 0',
  'error.minAmountFiat': 'Minimali suma yra {min} {currency}',
  'error.minAmountCrypto': 'Minimali suma yra {min} {currency}',
  'error.noProviders': 'Nėra teikėjų šiam derinukui',
  'error.currencyUnavailableBuy': 'Ši valiuta nėra prieinama pirkimo užsakymams',
  'error.currencyUnavailableSell': 'Ši valiuta nėra prieinama pardavimo užsakymams',
  'parity.info': 'Jums bus priskaičiuota už {receiveAmount} {crypto}, likutis iki {spendAmount} {fiat} bus įskaitytas į jūsų {partner} sąskaitą',
  'redirect.secureBadge': 'Saugus mokėjimas',
  'redirect.title': 'Tęsti mokėjimą',
  'redirect.description': 'Būsite nukreipti į {gateway}, kad užbaigtumėte mokėjimą.',
  'redirect.countdown': 'Nukreipiama po {seconds}...',
  'redirect.openTab': 'Atidaryti ACH naujame skirtuke',
  'redirect.cancel': 'Atšaukti',
  'checkout.noOrder': 'Užsakymas nerastas',
  'checkout.goBack': 'Grįžti',
  'checkout.expired': 'Atsiskaitymo laikas baigėsi',
  'checkout.expiredDesc': 'Sesijos laikas baigėsi. Bandykite dar kartą.',
  'checkout.startOver': 'Pradėti iš naujo',
  'checkout.cancel': 'Atšaukti',
  'checkout.loading': 'Kraunamas atsiskaitymas...',
  'checkout.iframeTitle': 'Teikėjo atsiskaitymas',
  'checkout.widgetTitle': 'Mokėjimo atsiskaitymas',
  'checkout.unknownMethod': 'Nežinomas atsiskaitymo būdas',
  'processing.default': 'Apdorojamas jūsų užsakymas...',
  'processing.pending': 'Laukiama mokėjimo patvirtinimo...',
  'processing.active': 'Apdorojama jūsų operacija...',
  'processing.generic': 'Apdorojama...',
  'processing.checkingStatus': 'Tikrinama būsena...',
  'processing.orderId': 'Užsakymo ID',
  'processing.provider': 'Teikėjas',
  'processing.amount': 'Suma',
  'processing.receiving': 'Gaunama',
  'processing.network': 'Tinklas',
  'processing.toAddress': 'Gavėjo adresas',
  'processing.usuallyMinutes': 'Paprastai tai užtrunka kelias minutes.',
  'processing.safeToClose': 'Galite saugiai uždaryti šį puslapį — atsiųsime jums el. laišką, kai viskas bus baigta.',
  'complete.buyTitle': 'Pirkimas atliktas!',
  'complete.sellTitle': 'Pardavimas atliktas!',
  'complete.buyDesc': 'Jūsų {crypto} buvo išsiųsta į jūsų piniginę.',
  'complete.sellDesc': 'Jūsų {fiat} išmokėjimas yra apdorojamas.',
  'complete.amountBuy': 'Gauta suma',
  'complete.amountSell': 'Parduota suma',
  'complete.paidBuy': 'Sumokėta suma',
  'complete.paidSell': 'Išmokėjimo suma',
  'complete.network': 'Tinklas',
  'complete.wallet': 'Piniginė',
  'complete.transaction': 'Operacija',
  'complete.provider': 'Teikėjas',
  'complete.orderId': 'Užsakymo ID',
  'complete.completed': 'Atlikta',
  'complete.viewExplorer': 'Peržiūrėti naršyklėje',
  'complete.done': 'Baigta',
  'errorStep.failed': 'Mokėjimas nepavyko',
  'errorStep.cancelled': 'Užsakymas atšauktas',
  'errorStep.expired': 'Užsakymo laikas baigėsi',
  'errorStep.refunded': 'Užsakymas grąžintas',
  'errorStep.unknown': 'Kažkas nutiko ne taip',
  'errorStep.failedBuy': 'Jūsų mokėjimas negalėjo būti apdorotas. Bandykite dar kartą arba naudokite kitą mokėjimo būdą.',
  'errorStep.failedSell': 'Jūsų pardavimas negalėjo būti apdorotas. Bandykite dar kartą.',
  'errorStep.cancelledBuy': 'Jūsų užsakymas buvo atšauktas. Joks mokėjimas nebuvo apdorotas.',
  'errorStep.cancelledSell': 'Jūsų pardavimas buvo atšauktas. Jokia kriptovaliuta nebuvo perkelta.',
  'errorStep.expiredBuy': 'Jūsų užsakymo laikas baigėsi. Pradėkite naują pirkimą.',
  'errorStep.expiredSell': 'Jūsų užsakymo laikas baigėsi. Pradėkite naują pardavimą.',
  'errorStep.refundedBuy': 'Jūsų mokėjimas buvo grąžintas. Lėšos turėtų atsirasti jūsų sąskaitoje per 5–10 darbo dienų.',
  'errorStep.refundedSell': 'Jūsų kriptovaliuta buvo grąžinta. Lėšos turėtų netrukus atsirasti jūsų piniginėje.',
  'errorStep.genericDesc': 'Įvyko netikėta klaida. Bandykite dar kartą.',
  'errorStep.orderId': 'Užsakymo ID',
  'errorStep.tryAgain': 'Bandyti dar kartą',
  'errorStep.startOver': 'Pradėti iš naujo',
  'errorStep.return': 'Grįžti',
  'errorStep.needHelp': 'Reikia pagalbos? Susisiekite su ',
  'errorStep.reference': 'Nuoroda: {orderId}',
  'confirm.buyTitle': 'Patvirtinti pirkimą',
  'confirm.sellTitle': 'Patvirtinti pardavimą',
  'confirm.loading': 'Kraunama...',
  'confirm.provider': 'Teikėjas',
  'confirm.youPay': 'Jūs mokate',
  'confirm.youSell': 'Jūs parduodate',
  'confirm.youReceive': 'Jūs gaunate',
  'confirm.wallet': 'Piniginė',
  'confirm.network': 'Tinklas',
  'confirm.refundAddress': 'Grąžinimo adresas',
  'confirm.parityNote': 'Teikėjo nurašyta suma gali skirtis. Likutis iki {amount} {crypto} bus įskaitytas į jūsų {partner} sąskaitą.',
  'confirm.processing': 'Apdorojama...',
  'confirm.confirmPay': 'Patvirtinti ir mokėti',
  'confirm.confirmSell': 'Patvirtinti ir parduoti',
  'confirm.payout': '{currency} išmokėjimas',
  'modal.selectFiat': 'Pasirinkite fiat valiutą',
  'modal.selectCrypto': 'Pasirinkite kriptovaliutą',
  'modal.choosePayment': 'Pasirinkite mokėjimo būdą',
  'modal.selectCountry': 'Pasirinkite savo šalį',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Populiaru',
  'modal.recommended': 'Rekomenduojama',
  'modal.noCurrencies': 'Valiutų nerasta',
  'modal.noPaymentMethods': 'Mokėjimo būdų nerasta',
  'modal.noCountries': 'Šalių nerasta',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Vieta',
  'settings.darkMode': 'Tamsusis režimas',
  'settings.privacy': 'Privatumo politika',
  'settings.terms': 'Naudojimo sąlygos',
  'settings.language': 'Kalba',
  // ─── Additional ───
  'modal.chooseRamp': 'Pasirinkti Ramp',
  'modal.bestPrice': 'Geriausia kaina',
  'modal.noQuotes': 'Šiai užklausai nėra kainų',
  'modal.noProvidersFound': 'Teikėjų nerasta',
  'payment.unavailableFor': 'Nėra mokėjimo būdų {currency} valiutai',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'Nepavyko sukurti užsakymo',
  'errorStep.returnToMerchant': 'Grįžti pas pardavėją',
  'confirm.cryptoOnNetwork': '{crypto} tinkle {network}',
  'payment.name.card': 'Kortelė',
  'payment.name.bankTransfer': 'Banko pervedimas',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default lt;
